import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { User } from '@app/shared/models/user';
import { Sso } from '@app/shared/models/sso';
import { DashboardData } from '@app/shared/models/dashboardData';
import { environment } from 'environments/environment';
import { RequestService } from './request.service';
import { URLSearchParams } from '@angular/http';
import { NGXLogger } from '@app/shared';

@Injectable()
export class UserService implements RequestService {

  user: User;
  sso: Sso;
  redirectUrl: String = "";
  isBusy = false;
  private loggedIn = false;
  private userUrl = 'sso/auth';  // URL to web api
  private ssoUrl = 'sso/ak';

  constructor(
    private http: HttpClient,
    private logger: NGXLogger
    ) { }

  /** GET productes from the server */
  // getUser (): Observable<User[]> {
  //   return this.http.get<User[]>(this.userUrl)
  //     .pipe(
  //       tap(user => this.logger.debug(`fetched user`)),
  //       catchError(this.handleError('getUser', {}))
  //     );
  // }

  /** GET product by id. Return `undefined` when id not found */
  getUserNo404<Data>(id: number): Observable<User> {
    const url = `${environment.baseURL}${this.userUrl}?id=${id}`;
    return this.http.get<User[]>(url)
      .pipe(
        map(productes => productes[0]), // returns a {0|1} element array
        tap(h => {
          const outcome = h ? `fetched` : `did not find`;
          this.logger.debug(`${outcome} product id=${id}`);
        }),
        catchError(this.handleError<User>(`getUser id=${id}`))
      );
  }

  /** GET product by id. Will 404 if id not found */
  getUser(id: number): Observable<User> {

    const url = `${environment.baseURL}/${this.userUrl}/${id}`;
    return this.http.get<User>(url).pipe(
      tap(_ => this.logger.debug(`fetched user id=${id}`)),
      catchError(this.handleError<User>(`getUser id=${id}`))
    );
  }

  getLoggedInUser():User{
    if(this.isLoggedIn()){
      let tmpUser = JSON.parse(localStorage.getItem("user"));

      return tmpUser;
    }
  }
  /** GET product by id. Will 404 if id not found */
  auth(username: string, password:string): Observable<User> {
    const body = {username: encodeURI(username), password: password};
    const url = `${environment.baseURL}${this.userUrl}`;

    this.isBusy = true;

    let httpParams = new HttpParams();
    Object.keys(body).forEach(function (key) {
         httpParams = httpParams.append(key, body[key]);
    });
    let _inst = this;

    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    headers.append('Access-Control-Allow-Origin', 'http://localhost:4200');
    headers.append('Access-Control-Allow-Credentials', 'true');

    let urlSearchParams = new URLSearchParams();
        urlSearchParams.append('username', encodeURIComponent(username));
        urlSearchParams.append('password', password);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<User>(url,bodyParams,{
       //params : httpParams
       headers: headers,
    })

  }

  sso2(ak:string): Observable<Sso> {
    const url = `${environment.baseURL}${this.ssoUrl}`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    let urlSearchParams = new URLSearchParams();
        urlSearchParams.append('ak', ak);

    let bodyParams = urlSearchParams.toString();
    return this.http.post<Sso>(url,bodyParams,{
       //params : httpParams
       headers: headers,
    })

  }

  /** GET product by id. Will 404 if id not found */
  logError(payload:any) {
    const url = `${environment.baseURL}log/save`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let formData = new URLSearchParams();
    formData.append('message', payload.message);
    formData.append('level', payload.level);
    //formData.append('additional', payload.additional);
    formData.append('timestamp', payload.timestamp);

    // formData.append('fileName',payload.filename);
    // formData.append('fileName',payload.filename);

    let bodyParams = formData.toString();

    this.http.post<any>(url,bodyParams,{
       //params : httpParams
       headers: headers,
    }).subscribe(data => { console.log(data); },
    error => {
        console.log('Error Logging: ', error);
    });



  }


  /** Log the user out and set the user to null **/
  logout(user:User):Observable<User> {

    const url = `${environment.baseURL}logout`;

    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    headers.append('Access-Control-Allow-Origin', 'http://localhost:4200');
    headers.append('Access-Control-Allow-Credentials', 'true');

    let token = user.fbToken?user.fbToken:'';

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('token', token);
    urlSearchParams.append('userAgent', user.userAgent);

    let bodyParams = urlSearchParams.toString();
    this.loggedIn = false;

    //localStorage.removeItem("user");
    // observer.next(this.loggedIn);
    // observer.complete()
    return this.http.post<User>(url,encodeURI(bodyParams),{
       //params : httpParams
       headers: headers,
    })
    //return new Observable((observer) => {
        // observable execution

    //});

  }

  isLoggedIn(){
    //this.logger.debug(this.loggedIn, this.user, this.tmpUser);
    this.logger.debug(localStorage.getItem("user"))
    let tmpUser = JSON.parse(localStorage.getItem("user"));
  //  this.logger.debug(user, user.session)
    //if(tmpUser && tmpUser.session){
    if(tmpUser){
      this.loggedIn = true;
      //this.user = tmpUser;
    }
    return this.loggedIn;
  }

  getUserDash(): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}person/dashboard/data`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<DashboardData>(url,{
       //params : httpParams
       headers: headers
    })

  }
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.logger.debug(`${operation} failed: ${error.message}`);

      // log the user out
      this.loggedIn = false;
      // Let the app keep running by returning an empty result.

      return of(result as T);
    };
  }

  /** Log a UserService message with the MessageService */
  private log(message: string) {
    //this.messageService.add('UserService: ' + message);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/user.service.ts